module.exports = __webpack_public_path__ + "img/active-action-icon.5da0d033.svg";